import { Injectable } from "@angular/core";
import gql from "graphql-tag";
import { Subscription } from "apollo-angular";

const GET_DUMMY_DATA = gql`
  query doGetMQTTDevices {
    doGetMQTTDevices {
      id
    }
  }
`;
const GET_MQTT_DATA = gql`
  subscription {
    doGetMqttData {
      topic
      payload {
        fecha
        valor
      }
    }
  }
`;

@Injectable({
  providedIn: "root",
})
export class MQTTService extends Subscription {
  listen() {
    return this.apollo.subscribe<any>({
      query: GET_MQTT_DATA,
      fetchPolicy: "no-cache",
    });
  }
}
